import { render, staticRenderFns } from "./proxyTrade.vue?vue&type=template&id=7d3530c4&scoped=true&"
import script from "./proxyTrade.vue?vue&type=script&lang=js&"
export * from "./proxyTrade.vue?vue&type=script&lang=js&"
import style0 from "./proxyTrade.vue?vue&type=style&index=0&id=7d3530c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3530c4",
  null
  
)

export default component.exports